import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/invoices/invoice-batch-profile/loading';

export const Route = createFileRoute('/_private/invoices/invoice-batch/$id')({
  pendingComponent: Loading,
});
